import {useRef, useState} from 'react';
import styles from "./SignUp.module.css"

import {Link, useNavigate} from "react-router-dom"

import { db } from '../../firebase';
import { doc, setDoc } from "firebase/firestore"; 

import { useAuth } from '../../contexts/authContext';

import googleLogo from "./googleLogo.png"
import twitterLogo from "./twitterLogo.png"

export default function SignUp() {
  const usernameRef = useRef()
  const emailRef = useRef()
  const passwordRef = useRef()
  const passwordConfirmRef = useRef()

  const [error, setError] = useState("")
  const [loading, setLoading] = useState(false);

  const {signup, currentUser, continueWithGoogle, continueWithTwitter} = useAuth()

  const navigate = useNavigate();

  async function handleSubmit(e) {
    e.preventDefault();

    if(passwordRef.current.value !== passwordConfirmRef.current.value) {
      return setError("Passwords do not match");
    }

    try {
      setError("")
      setLoading(true)

      const { user } = await signup(emailRef.current.value, passwordRef.current.value)

      await setDoc(doc(db, "users", user.uid), {
        displayName: usernameRef.current.value
      });

      navigate("/")
    } catch(e) {
      setError("Failed to sign up")
      console.log(e)
    }

    setLoading(false)
  }

  async function handleGoogleSignIn() {
    await continueWithGoogle();
  }

  async function handleTwitterSignIn() {
    await continueWithTwitter();
  }

  return (
    <div className={styles.signupContainer}>
      <h2>Sign Up</h2>

      {error && <p>{error}</p>}

      <form className={styles.signupForm} onSubmit={handleSubmit}>
        <label htmlFor="username">Username</label>
        <input type="text" placeholder="Display Name" ref={usernameRef} />

        <label htmlFor="email">Email</label>
        <input type="email" id="email" placeholder="name@example.com" ref={emailRef} />

        <label htmlFor="password">Password</label>
        <input type="password" id="password" placeholder="password" ref={passwordRef} />

        <label htmlFor="password-confirm">Confirm your password</label>
        <input type="password" id="password-confirm" placeholder="password" ref={passwordConfirmRef} />

        <button type="submit" disabled={loading}>Sign up</button>
      </form>

      <p>Or</p>

      <button onClick={handleGoogleSignIn} className={`${styles.oauthBtn} ${styles.googleBtn}`}><img src={googleLogo} /> Continue with Google</button>
      <button onClick={handleTwitterSignIn} className={`${styles.oauthBtn} ${styles.twitterBtn}`}><img src={twitterLogo} /> Continue with Twitter</button>

      <p>Already a member? <Link to="/login">Login</Link></p>
    </div>
  );
}
